import styles from './styles.module.scss';
import Layout from '@/components/core/Layout';
import TournamentsPageTabs from './Tabs';
import TournamentsPageContent from './Content';
import TournamentsHero from './Hero';

export default function TournamentsPage() {
  return (
    <Layout>
      <div className={styles.container}>
        <TournamentsHero />
        <TournamentsPageTabs />
        <TournamentsPageContent />
      </div>
    </Layout>
  );
}
